import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
    name: 'rmsTimeagoExtended',
    standalone: false
})
export class RmsTimeagoExtendedPipe implements PipeTransform {

  transform(value: string, args?: any): any {
    if ( !value ) {
      return value;
    }
    // Constants
    const MAX_MONTHS = 20;
    const YEAR_MONTHS = 12;
    const AGO = 'ago';
    const PLURAL = 's';
    const YEARS = 'years';
    const PROX_SIMBOL = '~';
    const APPROX_2_YEARS = '~2 years ago';
    const WITHOUT_PROX_DIFF = [1, 2, 11, 12];
    // --- Calcs --- //
    const today: any = new Date();
    const date: any = new Date(value);
    const seconds = Math.round((today - date) / 1000);
    const minutes = Math.round(seconds / 60);
    const hours = Math.round(minutes / 60);
    const days = Math.round(hours / 24);
    const months = Math.round(DateTime.fromJSDate(today).diff(DateTime.fromJSDate(date), 'months').months);
    const years = Math.round(DateTime.fromJSDate(today).diff(DateTime.fromJSDate(date), YEARS).years);

    // Vars
    let agoDate = '';
    // Calc the 20+ month labels or year labels
    if ( years > 0 && months > MAX_MONTHS) {
      // Calc the total years + 1 months less the total months diff
      const diffMonths = (((years + 1) * YEAR_MONTHS) - months);
      const proximity = WITHOUT_PROX_DIFF.includes(diffMonths) ? '' : PROX_SIMBOL;
      // 6 or less on diff months +1 year
      if (diffMonths < 7) {
        agoDate = `${proximity}${years + 1} ${YEARS} ${AGO}`;
      // 7 or more on diff months 1 year
      } else {
        agoDate = `${proximity}${years} ${YEARS} ${AGO}`;
      }
    } else if ( months > 0 ) {
      const m = today.getDate() > 15 ? months + 1 : months;
      // m can be 1 to 21, so 21 is an exception in this rule and should be display as ~2 years ago
      agoDate = m < 21 ? `${m} month${m === 1 ? '' : PLURAL} ${AGO}` : APPROX_2_YEARS;
    } else if ( days > 0 ) {
      agoDate = `${days} day${days === 1 ? '' : PLURAL} ${AGO}`;
    } else if ( hours > 0 ) {
      agoDate = `${hours} hour${hours === 1 ? '' : PLURAL} ${AGO}`;
    } else if ( minutes > 0 ) {
      agoDate = `${minutes} minute${minutes === 1 ? '' : PLURAL} ${AGO}`;
    } else if ( seconds > 0 ) {
      agoDate = `${seconds} second${seconds === 1 ? '' : PLURAL} ${AGO}`;
    }
    return agoDate;
  }

}
